export enum CpwResolutionCustomFields {
    QuarantineReason = 'QuarantineReason',
    DisposalReason = 'DisposalReason',
    DisposalMethod = 'DisposalMethod',
    DisposalApprovedBy = 'DisposalApprovedBy',
    DisposalApprovalRequested = 'DisposalApprovalRequested',
    TransferReason = 'TransferReason',
    TransferToWarehouseId = 'TransferToWarehouseId',
    Packages = 'Packages',
    RTVVendorId = 'RTVVendorId',
    ShipmentId = 'ShipmentId',
}
